"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var quards_1 = require("../../../utils/quards");
var selectors_1 = require("../selectors");
var SeoText = function (props) {
    var className = props.className, _a = props.tag, tag = _a === void 0 ? 'div' : _a, type = props.type;
    var text = (0, quards_1.guardString)((0, selectors_1.useSeoTypeSelector)(type));
    return text
        ? react_1.default.createElement(tag, {
            className: className,
            dangerouslySetInnerHTML: { __html: text.trim() },
        })
        : null;
};
exports.default = SeoText;
